import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import App from "../components/App";
import { ConfigProvider } from "antd";
import { createRoot } from 'react-dom/client';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';


document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById('shipment_management_container');
  if (!container) return;
  const root = createRoot(container);
  mixpanel.init("ecc284c3351f29d4953b44c1da1909d5");
  
  root.render(
    <MixpanelProvider mixpanel={mixpanel}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#F9A529',
            boxShadow: 'none',
            colorLinkHover: '#F9A529',
            colorLinkActive: '#F9A529',
            colorLink: '#F9A529',
          },
        }}
      >
        <App />
      </ConfigProvider>
    </MixpanelProvider>
  );
});

